"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MeasureText = require("../utils/MeasureText");

var _Styles = require("../utils/Styles");

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _MeasureInput = _interopRequireDefault(require("../decorators/MeasureInput"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _UITextArea = _interopRequireDefault(require("./UITextArea"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-height: ", " !important;\n  overflow: ", " !important;\n\n  /* Extra specificity to override UITextArea styles */\n  && {\n    /* Prevent visual glitch on height increase */\n    transition: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTextArea = (0, _styledComponents.default)(function (props) {
  var __height = props.height,
      __maxHeight = props.maxHeight,
      rest = (0, _objectWithoutProperties2.default)(props, ["height", "maxHeight"]);
  return _react.default.createElement(_UITextArea.default, rest);
}).withConfig({
  displayName: "UIExpandingTextArea__StyledTextArea",
  componentId: "sc-1oqaaw2-0"
})(_templateObject(), function (_ref) {
  var maxHeight = _ref.maxHeight;
  return maxHeight < Infinity && (0, _Styles.toPx)(maxHeight);
}, function (_ref2) {
  var height = _ref2.height,
      maxHeight = _ref2.maxHeight;
  return height > maxHeight ? 'auto' : 'hidden';
});

var getStyle = function getStyle(height) {
  return {
    height: height
  };
};

var UIExpandingTextArea =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIExpandingTextArea, _PureComponent);

  function UIExpandingTextArea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIExpandingTextArea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIExpandingTextArea).call(this, props));
    _this.state = {
      height: null
    };
    _this.setHeight = _this.setHeight.bind((0, _assertThisInitialized2.default)(_this));
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this._hasUpdated = false;
    return _this;
  }

  (0, _createClass2.default)(UIExpandingTextArea, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.height === this.state.height) {
        this.setHeight(!this._hasUpdated);
        this._hasUpdated = true;
      }
    }
  }, {
    key: "setHeight",
    value: function setHeight(initial) {
      var _this$props = this.props,
          inputRef = _this$props.inputRef,
          minHeight = _this$props.minHeight,
          shrink = _this$props.shrink;
      var textAreaNode = inputRef.current;
      if (!textAreaNode) return;
      var textHeight = (0, _MeasureText.getTextHeight)(textAreaNode);
      var newHeight;

      if (shrink) {
        newHeight = Math.max(minHeight, textHeight);
      } else {
        // Ensure that we don't reduce height below what the user set by manually resizing
        var measuredHeight = initial ? 0 : textAreaNode.getBoundingClientRect().height;
        newHeight = Math.max(minHeight, textHeight, measuredHeight);
      }

      if (this.state.height !== newHeight) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          __inputWidth = _this$props2.inputWidth,
          __minHeight = _this$props2.minHeight,
          resize = _this$props2.resize,
          shrink = _this$props2.shrink,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["inputWidth", "minHeight", "resize", "shrink"]);
      var height = this.state.height;
      return _react.default.createElement(StyledTextArea, (0, _extends2.default)({}, rest, {
        resize: shrink ? false : resize,
        style: this._getStyle(height),
        height: height
      }));
    }
  }]);
  return UIExpandingTextArea;
}(_react.PureComponent);

UIExpandingTextArea.propTypes = (0, _extends2.default)({}, _UITextArea.default.propTypes, {
  inputRef: _refObject.default.isRequired,
  maxHeight: _react.PropTypes.number.isRequired,
  minHeight: _react.PropTypes.number.isRequired,
  shrink: _react.PropTypes.bool.isRequired
});
UIExpandingTextArea.defaultProps = (0, _extends2.default)({}, _UITextArea.default.defaultProps, {
  maxHeight: Infinity,
  minHeight: 0,
  shrink: false
});
UIExpandingTextArea.displayName = 'UIExpandingTextArea';

var _default = (0, _Controllable.default)((0, _ShareInput.default)((0, _MeasureInput.default)(UIExpandingTextArea)));

exports.default = _default;
module.exports = exports.default;